// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M19.291 8.024a.803.803 0 0 0-.492.44.782.782 0 0 0-.041.284c-.002.327-.044.274 1.387 1.71l1.274 1.278H11.086c-7.293 0-10.375.008-10.476.026a.75.75 0 0 0-.61.748c0 .268.164.526.42.662l.12.064 10.452.006 10.451.006-1.299 1.302c-1.446 1.45-1.39 1.38-1.387 1.71.002.21.07.373.21.51.17.166.283.21.533.21.184 0 .233-.009.33-.06.17-.09 4.033-3.956 4.1-4.104.027-.06.06-.127.072-.15.03-.057.029-.361-.002-.342-.013.008-.024-.002-.024-.023 0-.138-.15-.299-2.08-2.226-1.585-1.583-1.986-1.97-2.077-2.01a.908.908 0 0 0-.528-.04M.008 12.503c0 .099.004.14.01.09.005-.05.005-.13 0-.18-.006-.05-.01-.009-.01.09"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const KeyboardArrowRightIcon = Icon;
export default KeyboardArrowRightIcon;
